if (typeof window.ScrollObserver === "undefined") {
  window.ScrollObserver = class ScrollObserver {
    static observers = new Map();
    static elements = new Map();
    static initialized = false;
    static scrollListener = null;

    constructor() {
      if (this.initialized) return;
      this.initialized = true;
    }

    static calculateProgress(element) {
      const rect = element.getBoundingClientRect();
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // Calculate progress based on element position
      const progress =
        (scrollY - (rect.top + scrollY - windowHeight)) /
        (rect.height + windowHeight);

      // Clamp between 0 and 1
      return Math.max(0, Math.min(1, progress));
    }

    static watch(element, callback, options = {}) {
      const cssVariable = options.cssVariable || "--progress";

      // Don't observe if user prefers reduced motion
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        element.style.setProperty(cssVariable, "0");
        return () => {};
      }

      // Store element info
      this.elements.set(element, { callback, cssVariable });

      // Setup scroll listener if not already setup
      if (!this.scrollListener) {
        this.scrollListener = () => {
          window.requestAnimationFrame(() => {
            this.elements.forEach((info, el) => {
              const progress = this.calculateProgress(el);
              el.style.setProperty(info.cssVariable, progress);
              if (info.callback) {
                info.callback(progress);
              }
            });
          });
        };

        window.addEventListener("scroll", this.scrollListener, {
          passive: true,
        });
        // Initial calculation
        this.scrollListener();
      }

      // Return unwatch function
      return () => this.unwatch(element);
    }

    static unwatch(element) {
      if (!this.elements.has(element)) return;

      const elementInfo = this.elements.get(element);
      element.style.removeProperty(elementInfo.cssVariable);
      this.elements.delete(element);

      // Remove scroll listener if no more elements
      if (this.elements.size === 0 && this.scrollListener) {
        window.removeEventListener("scroll", this.scrollListener);
        this.scrollListener = null;
      }
    }
  };
}
